// Testi verificati sulla dashboard il 2026-10-16 (vedi spec guide richieste, note spese e report).
export default {
  slug: 'report',
  module: 'reports',
  title: 'I report',
  tile: 'Trova in un attimo i numeri su presenze, utenti e documenti e scaricali in Excel.',
  minutes: 3,
  publishedAt: '2026-10-26T12:00:00.000Z',
  moduleLabel: 'Apri i report',
  modulePath: 'reports',
  brief: {
    purpose: 'Avere in un attimo i numeri su presenze, utenti e documenti, e scaricarli in Excel.',
    who: 'Chi in azienda controlla dati e scadenze.',
    when: 'A fine mese o quando ti serve un riepilogo.',
  },
  steps: [
    {
      title: 'La pagina Report',
      text: 'In Report trovi una scheda per ogni report: cliccala per aprirlo.',
      screen: 'report-1',
      notes: ['Ogni scheda è un report: titolo e cosa contiene'],
    },
    {
      title: 'Ore e presenze',
      text: 'La scheda «cartellino» apre le statistiche delle ore lavorate; con «Esporta (.xlsx)» scarichi il file.',
      screen: 'report-2',
      notes: ['«Esporta (.xlsx)» scarica le statistiche in Excel'],
    },
    {
      title: 'Utenti e accessi',
      text: '«Utenti» mostra lo stato degli account dei dipendenti e la verifica in due passaggi (MFA); «Accesso documenti» mostra chi ha aperto quali documenti e quando.',
      screen: 'report-3',
      notes: ['Stato dell’account del dipendente', 'MFA: la verifica in due passaggi è attiva o no'],
    },
    {
      title: 'Scarica in Excel',
      text: 'Nei report trovi «Esporta in XLS» per scaricare i dati.',
      screen: 'report-4',
      notes: ['«Esporta in XLS» scarica i dati che vedi'],
    },
  ],
  faq: [
    {
      question: 'Non vedo alcuni report',
      answer: 'Alcuni report dipendono dalle funzioni attive per la tua azienda o si vedono solo da computer.',
    },
    {
      question: 'Posso scegliere io le colonne?',
      answer: 'Nel report che apri puoi mostrare o nascondere le colonne con il pulsante delle colonne prima di esportare.',
    },
  ],
};
